/**
 * Integrations → Payment connections: the native read-only connectors
 * (PayPlus, Grow, Tranzila, Cardcom — Business Hub H5). Spread into
 * enIntegrationTiles. Every sentence is pending Marketing review —
 * TODO(copy-GO). Provider names are brands and stay untranslated.
 */
export const enPaymentConnectors = {
  // TODO(copy-GO)
  'paymentConnectors.title': 'Connect a payment provider',
  // TODO(copy-GO)
  'paymentConnectors.lead': 'Read-only: BuzzBit X reads what you sell and who bought it. It never charges, refunds or changes anything at the provider.',
  'paymentConnectors.provider.payplus': 'PayPlus',
  'paymentConnectors.provider.grow': 'Grow (Meshulam)',
  'paymentConnectors.provider.tranzila': 'Tranzila',
  'paymentConnectors.provider.cardcom': 'Cardcom',
  'paymentConnectors.field.apiKey': 'API key',
  'paymentConnectors.field.secretKey': 'Secret key',
  'paymentConnectors.field.terminalUid': 'Terminal UID',
  'paymentConnectors.field.userId': 'User ID',
  'paymentConnectors.field.pageCode': 'Page code',
  'paymentConnectors.field.terminalName': 'Terminal name',
  'paymentConnectors.field.appKey': 'App key',
  'paymentConnectors.field.secret': 'Secret',
  'paymentConnectors.field.terminalNumber': 'Terminal number',
  'paymentConnectors.field.apiName': 'API name',
  'paymentConnectors.field.apiPassword': 'API password',
  'paymentConnectors.sandbox': 'Sandbox / test account',
  'paymentConnectors.connect': 'Connect',
  // TODO(copy-GO)
  'paymentConnectors.connected': 'Connected. Checking the key and reading history now.',
  // TODO(copy-GO)
  'paymentConnectors.failed': 'Could not connect. Check the keys and try again.',
  // TODO(copy-GO)
  'paymentConnectors.callbackHowTo': 'Paste this URL as the notify / webhook URL in your provider. It carries a private key — keep it secret.',
  'paymentConnectors.syncNow': 'Sync now',
  // TODO(copy-GO)
  'paymentConnectors.syncStarted': 'Sync started.',
  // TODO(copy-GO)
  'paymentConnectors.syncFailed': 'Could not start the sync. Try again in a minute.',
  // TODO(copy-GO)
  'paymentConnectors.error.credentials_revoked': 'The provider refused the saved key. Connect it again with a new key to resume.',
  // TODO(copy-GO)
  'paymentConnectors.error.rate_limited': 'The provider asked us to slow down. Syncing resumes where it stopped on the next run.',
  // TODO(copy-GO)
  'paymentConnectors.error.provider_unavailable': 'The provider could not be reached. Try Sync now in a few minutes.',
  // TODO(copy-GO)
  'paymentConnectors.error.provider_not_found': 'The provider did not recognise this account. Check the terminal or account ID, then try Sync now.',
  // TODO(copy-GO)
  'paymentConnectors.error.missing_permission': 'The key works but lacks a read permission this sync needs. Give it read access at the provider, then try Sync now.',
} as const;
